<template>
  <Modal @close="$emit('close')" width="500px">

      <h2>{{ text }}</h2>

      <div v-if="isSave" class="button__wraper">
        <Button
          @click="$emit('save')"
          :loading="loading"
          class="btn-primary"
          width="190px"
          height="40px"
          text="Все равно сохранить"
        />
        <Button
          class="btn-secondary"
          width="96px"
          height="40px"
          text="Отмена"
          @click="$emit('close')"
        />
      </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modals/Modal.vue";
import Button from "@/components/Button.vue";

export default {
  components: {
    Button,
    Modal
  },
  props: {
    text: {
      type: String,
      default: () => '',
    },
    isSave: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.button__wraper {
  margin-top: 30px;
}
</style>
